<template>
  <mdb-file-input
    @getValue="getFileInputValue"
    :width="imageWidth"
    btnColor="mdb-color"
    :btn-title="buttonName"
    rounded
    :img="image"
    :src="imageSrc"
  />
</template>

<script>
import { mdbFileInput } from "mdbvue";
export default {
  name: "ImageInput",
  components: {
    mdbFileInput
  },
  props: {
    imageWidth: Number,
    defaultMarker: Object,
    imageSrc: String,
    buttonName: String,
  },
  data: () => ({
    image: true,
  }),
  methods: {
    getFileInputValue(val) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("general-image", e.target.result);
      }
      reader.readAsDataURL(val[0]);
    }
  }
};
</script>

<style></style>
